<template>
  <DoNotSellFormLoggedIn v-if="loggedIn"></DoNotSellFormLoggedIn>
  <DoNotSellFormLoggedOut v-else></DoNotSellFormLoggedOut>
</template>

<script lang="ts">
import DoNotSellFormLoggedIn from './DoNotSellFormLoggedIn.vue';
import DoNotSellFormLoggedOut from './DoNotSellFormLoggedOut.vue';
import { readDomainCookie } from '../../lib/domain_cookie';

export default {
  name: 'DoNotSellForm',
  components: {
    DoNotSellFormLoggedIn,
    DoNotSellFormLoggedOut,
  },
  computed: {
    loggedIn(): boolean {
      const jwt = readDomainCookie('jwt');
      return !!jwt;
    },
  },
};
</script>
